module.exports = __webpack_public_path__ + "img/mobile-help-4.fd5ec071.jpg";